import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { usePractice } from "@/pages/StaffApp";

export default function PracticeProfile() {
  const { practice, reloadPractice, reloadMe } = usePractice();
  const [f, setF] = useState({ name: practice.name, short: practice.short || "", legal_entity: practice.legal_entity });
  const changed = Object.keys(f).filter((k) => f[k].trim() !== (practice[k] || ""));
  const save = async () => {
    try {
      await api.patch("/practice/profile", Object.fromEntries(changed.map((k) => [k, f[k].trim()])));
      toast.success("Organization details saved"); reloadPractice(); reloadMe?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const row = (k, label, help) => (
    <div><Label htmlFor={`pp-${k}`}>{label}</Label><Input id={`pp-${k}`} maxLength={{ name: 80, short: 12, legal_entity: 120 }[k]} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`practice-${k}-input`} />
      {help && <p className="text-xs text-slate-500 mt-1">{help}</p>}</div>
  );
  return (
    <div className="bg-white border rounded-xl p-5 space-y-4" data-testid="practice-profile">
      <div><h2 className="text-lg font-semibold">Organization details</h2><p className="text-sm text-slate-600">Shown in the organization switcher, on patient signing screens, messages and new PDFs.</p></div>
      {row("name", "Organization name")}
      {row("short", "Short name", "Used where space is tight, e.g. the organization switcher.")}
      {row("legal_entity", "Legal entity on consents", "Printed on consent PDFs. Changing it means existing consents signed under the old legal entity are no longer counted as valid for this one, so patients will be asked to sign again.")}
      {changed.includes("legal_entity") && <p className="text-sm rounded-md bg-amber-50 border border-amber-300 text-amber-900 p-2" data-testid="legal-entity-warning">You are changing the legal entity. Existing consents will need to be signed again.</p>}
      <Button className="btn-brand" disabled={!changed.length} onClick={save} data-testid="practice-profile-save">Save</Button>
    </div>
  );
}
